import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResponseNotificationService {
  private messageSubject = new BehaviorSubject<{ message: string, danger: boolean } | null>(null);
  message$ = this.messageSubject.asObservable();

  showMessage(message: string, danger: boolean = false) {
    this.messageSubject.next({ message, danger });
    setTimeout(() => {
      this.messageSubject.next(null);
    }, 5000); // Message will disappear after 5 seconds
  }
}
